<ng-container *transloco="let t; prefix: 'profileMapCta'">
  @if (name; as name) {
    <h2 class="mat-headline-5">
      <span [innerHtml]="t(canHaveProperties ? 'blurb' : 'mb-blurb', { name: name | possessive })"></span>
    </h2>
  }

  <rma-inline-map class="block h-96" [mapRequest]="mapRequest" [mapTypes]="mapTypes" fullscreenRoute="../map" />
</ng-container>
